<template>
<div class="chapter">
<div class="inner_page">
<p class="image-h"><a id="page_13"><img alt="image" src="html/images/f0013-01.jpg"/></a></p><a id="page_13">
<p class="h3" id="lev178">THE COMMON CART HORSE.</p>
<p class="noindent">IS inferior to the Black Horse both in size and strength: his form is heavy, his motions slow, and his aspect without sprightliness: he is nevertheless extremely useful, and is employed in the business of agriculture and other domestic concerns.</p>
<p class="image"><img alt="image" src="html/images/f0013-02.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226044859_14_ch6.vue?4d8423ad